import React, { useState, useEffect } from 'react'
import './styleNavbar.css'
import { Nav, Navbar, Container } from 'react-bootstrap';
import { Link } from "react-scroll";
import logo from '../../images/logo.png'

export const NavbarComponent = () => {
  const [navbar, setNavbar] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 200) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', changeBackground);
    return () => {
      window.removeEventListener('scroll', changeBackground);
    };
  }, []);

  const handleNavClick = () => {
    if (window.innerWidth <= 768) {
      setExpanded(false);
    }
  };

  return (
    <Navbar 
      expand="md" 
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
      className={navbar ? 'fixed-top style-navbar active' : 'fixed-top style-navbar'}
    >
      <Container>
        <Navbar.Brand href="#home">
          <img className="style-logo" src={logo} alt="Logo"/>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Item className="style-navitem">
              <Link 
                className="style-navlink"
                activeClass="active"
                to="home"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                onClick={handleNavClick}
              >
                HOME
              </Link>
            </Nav.Item>
            <Nav.Item className="style-navitem">
              <Link 
                className="style-navlink"
                activeClass="active"
                to="about"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                onClick={handleNavClick}
              >
                ABOUT
              </Link>
            </Nav.Item>
            <Nav.Item className="style-navitem">
              <Link 
                className="style-navlink"
                activeClass="active"
                to="tea"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                onClick={handleNavClick}
              >
                TEA
              </Link>
            </Nav.Item>
            <Nav.Item className="style-navitem">
              <Link 
                className="style-navlink"
                activeClass="active"
                to="contact"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                onClick={handleNavClick}
              >
                CONTACT
              </Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;

